<script lang="ts">
	export let actioned: boolean;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="15px"
	height="15px"
	viewBox="0 0 24 24"
	fill={actioned ? "currentColor" : "none"}
	stroke-width="1.5"
	color="currentColor"
	><path
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		d="M16.472 3.5H4.1a.6.6 0 0 0-.6.6v9.8a.6.6 0 0 0 .6.6h2.768a2 2 0 0 1 1.715.971l2.71 4.517a1.631 1.631 0 0 0 2.961-1.308l-1.022-3.408a.6.6 0 0 1 .574-.772h4.575a2 2 0 0 0 1.93-2.526l-1.91-7A2 2 0 0 0 16.473 3.5Z"
	/><path
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
		d="M7 14.5v-11"
	/></svg
>
